import React, { useState, useEffect } from "react";
import Chart from "react-google-charts";
import ReactApexChart from "react-apexcharts";
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  CardHeader,
} from "reactstrap";
import { useSelector } from "react-redux";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import "./AllReports.css";
import {
  googleChartData,
  comboChartData,
  comboChartOption,
} from "../../Data/ChartsData/GoogleChartData";
import DailyCallAverage from "./AllKPIs/DailyCallAverage";
import RoutesCoverage from "./AllKPIs/RoutesCoverage";
import CustomerCoverage from "./AllKPIs/CustomerCoverage";
import PCPM from "./AllKPIs/PCPM";
import FocusBrandAchievement from "./AllKPIs/FocusBrandAchievement";
import FarmerJagrutiMeeting from "./AllKPIs/FarmerJagrutiMeeting";
import Classification from "./AllKPIs/Classification";
import POB_POD from "./AllKPIs/POB_POD";
import ClassificationChart from "./AllKPIs/Classifications";
import AdministrationDays from "./AllKPIs/AdministrationDays";
import WeeklySalesPattern from "./AllKPIs/WeeklySalesPattern";
import Expense from "./AllKPIs/Expense";
import DemonstrationActivities from "./AllKPIs/DemonstrationActivities";
import DSO from "./AllKPIs/DSO";
import CreditLimit from "./AllKPIs/CreditLimit";
import Invoice from "./AllKPIs/Invoice";
import Payment from "./AllKPIs/Payment";
import ChequeBounce from "./AllKPIs/ChequeBounce";
import Expiry from "./AllKPIs/Expiry";
import SalesReturn from "./AllKPIs/SalesReturn";
import MonthlyEvaluationFormat from "./AllKPIs/MonthlyEvaluationFormat";
import TreeModelReport from "../Dashboards/Attendance/AttendanceTable/TreeModelReport";
import { RootState } from "../../redux-toolkit/store"; // Import the RootState type
import { H2, H3, H5, H6, Image, ProgressBar } from "../../AbstractElements";
import SvgIcon from "../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import {
  monthlyDropdownList,
  onlineOrderCardData,
  orderOverviewData,
} from "../../Data/DashboardsData/ECommerceData";
import { totalEarningCardsData } from "../../Data/DashboardsData/DefaultData";
import {
  OrderOverviewTitle,
  ThanLastWeek,
  TotalRevenue,
} from "../../Utils/Constants";
import DropdownWithHeader from "../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader";
import TopSell from "../AllKPIs/TopSell";
import CategorySales from "../AllKPIs/CategorySales";
import { getFilteredPositionIds } from "../../db/DexieServises";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { dynamicImage } from "../../Utils";
import MtpStatusByDesignation from "./AllKPIs/MtpStatusByDesignation";

// Render charts directly without using the CommonChart wrapper
export default function AllReports() {
  const positions = useSelector((state: RootState) => state.position.positions);
  const unitId = useSelector((state: RootState) => state.orgUnit.id);

  // Local filter state
  const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);

  // Chart configs for selection - Field Performance specific charts
  const chartConfigs = [
    {
      id: "dailyCallAverage",
      label: "Daily Call Average",
      render: () => <DailyCallAverage selectedPositionIds={selectedIds} />,
    },
    {
      id: "routesCoverage",
      label: "Routes Coverage",
      render: () => <RoutesCoverage selectedPositionIds={selectedIds} />,
    },
    {
      id: "mtpStatusByDesignation",
      label: "MTP Status By Designation",
      render: () => (
        <MtpStatusByDesignation selectedPositionIds={selectedIds} />
      ),
    },

    // {
    //   id: 'customerCoverage',
    //   label: 'Customer Coverage',
    //   render: () => <CustomerCoverage />,
    // },
    // {
    //   id: 'pcpm',
    //   label: 'PCPM',
    //   render: () => <PCPM />,
    // },
    // {
    //   id: 'focusBrandAchievement',
    //   label: 'Focus Brand Achievement',
    //   render: () => <FocusBrandAchievement />,
    // },
    // {
    //   id: 'farmerJagrutiMeeting',
    //   label: 'Farmer Jagruti Meeting',
    //   render: () => <FarmerJagrutiMeeting />,
    // },
    // {
    //   id: "classification",
    //   label: "Classification",
    //   render: () => <Classification />,
    // },
    // {
    //   id: 'pobPod',
    //   label: 'POB / POD',
    //   render: () => <POB_POD />,
    // },

    // {
    //   id: 'administrationDays',
    //   label: 'Administration Days',
    //   render: () => <AdministrationDays />,
    // },
    // {
    //   id: 'weeklySalesPattern',
    //   label: 'Weekly Sales Pattern',
    //   render: () => <WeeklySalesPattern />,
    // },
    // {
    //   id: 'expense',
    //   label: 'Expense',
    //   render: () => <Expense />,
    // },
    // {
    //   id: 'demonstrationActivities',
    //   label: 'Demonstration Activities',
    //   render: () => <DemonstrationActivities />,
    // },
    // {
    //   id: 'dso',
    //   label: 'DSO',
    //   render: () => <DSO />,
    // },
    // {
    //   id: 'creditLimit',
    //   label: 'Credit Limit',
    //   render: () => <CreditLimit />,
    // },
    // {
    //   id: 'invoice',
    //   label: 'Invoice',
    //   render: () => <Invoice />,
    // },
    // {
    //   id: 'payment',
    //   label: 'Payment',
    //   render: () => <Payment />,
    // },
    // {
    //   id: 'chequeBounce',
    //   label: 'Cheque Bounce',
    //   render: () => <ChequeBounce />,
    // },
    // {
    //   id: 'expiry',
    //   label: 'Expiry',
    //   render: () => <Expiry />,
    // },
    // {
    //   id: 'salesReturn',
    //   label: 'Sales Return',
    //   render: () => <SalesReturn />,
    // },
    // {
    //   id: 'monthlyEvaluationFormat',
    //   label: 'Monthly Evaluation Format',
    //   render: () => <MonthlyEvaluationFormat />,
    // },
  ];

  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [visibleCharts, setVisibleCharts] = useState(
    chartConfigs.map((c) => c.id),
  );
  console.log(visibleCharts, "=======visibleCharts========");

  const [selectedChartIds, setSelectedChartIds] = useState<string[]>(
    chartConfigs.map((c) => c.id),
  );
  const [allSelected, setAllSelected] = useState(true); // Track if all charts are selected
  const [selectedTreeIds, setSelectedTreeIds] = useState<(string | number)[]>(
    [],
  );
  const [monthRange, setMonthRange] = useState({
    from: { month: "", year: "" },
    to: { month: "", year: "" },
  });
  const [monthModalOpen, setMonthModalOpen] = useState(false); // Added state for month modal
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [topSellingFilter, setTopSellingFilter] = useState("default");
  const [topSellingMonthFilter, setTopSellingMonthFilter] = useState("default");
  const [categorySalesFilter, setCategorySalesFilter] = useState("default");
  const [categorySalesMonthFilter, setCategorySalesMonthFilter] =
    useState("default");
  const [topProducts, setTopProducts] = useState([
    { item: "ProtinC", quantity: 618, sales: 214 },
    { item: "AllGone", quantity: 1721, sales: 172 },
    { item: "ProtinC Keto+", quantity: 1206, sales: 121 },
    { item: "ReproPlus Gold", quantity: 776, sales: 85 },
    { item: "Crux LA", quantity: 530, sales: 81 },
    { item: "Hestaeaf CV", quantity: 593, sales: 77 },
    { item: "iHeal N", quantity: 321, sales: 68 },
    { item: "GPV", quantity: 680, sales: 67 },
    { item: "Kleanoxone", quantity: 576, sales: 62 },
    { item: "Decarnitox", quantity: 520, sales: 55 },
  ]);
  const [categorySales, setCategorySales] = useState([
    { name: "Therapeutics", value: 994, target: 1754 },
    { name: "Live Vaccines", value: 164, target: 570 },
    { name: "Inactivated Vaccines", value: 118, target: 167 },
    { name: "Feed Supplements", value: 373, target: 223 },
    { name: "Biosecurity", value: 118, target: 167 },
    { name: "Herbal Products", value: 118, target: 167 },
    { name: "Homeopathic Products", value: 118, target: 167 },
  ]);

  const currentYear = new Date().getFullYear();
  const yearOptions = [currentYear, currentYear - 1, currentYear - 2];

  const toggleMonthModal = () => setMonthModalOpen((prev: boolean) => !prev); // Fixed missing state and added type for 'prev'

  const getMonthRangeButtonLabel = () => {
    if (dateRange.start && dateRange.end) {
      return `${dateRange.start} to ${dateRange.end}`;
    }
    return "Select Month Range";
  };

  const handleApplyDateRange = () => {
    if (
      monthRange.from.month &&
      monthRange.from.year &&
      monthRange.to.month &&
      monthRange.to.year
    ) {
      const fromDate = `${monthRange.from.month}-${monthRange.from.year}`;
      const toDate = `${monthRange.to.month}-${monthRange.to.year}`;
      setDateRange({ start: fromDate, end: toDate });
      toggleMonthModal();
      // Recalculate averages after date range is applied
      setTimeout(() => {
        calculateAverages();
      }, 100);
    }
  };

  const monthToNumber = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12,
  } as const;

  const monthNumberToName: { [key: number]: string } = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const nameToMonthNumber: { [key: string]: number } = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12,
  };

  const handleTopSellingFilterChange = (filter: string) => {
    setTopSellingFilter(filter);
    setTopProducts(
      topProducts.map((prod) => ({
        ...prod,
        quantity: Math.floor(Math.random() * 100),
        sales: Math.floor(Math.random() * 200),
      })),
    );
  };

  const handleTopSellingMonthFilterChange = (filter: string) => {
    setTopSellingMonthFilter(filter);
    setTopProducts(
      topProducts.map((prod) => ({
        ...prod,
        quantity: Math.floor(Math.random() * 100),
        sales: Math.floor(Math.random() * 200),
      })),
    );
  };

  const handleCategorySalesFilterChange = (filter: string) => {
    setCategorySalesFilter(filter);
    setCategorySales(
      categorySales.map((cat) => ({
        ...cat,
        value: Math.floor(Math.random() * cat.target),
      })),
    );
  };

  const handleCategorySalesMonthFilterChange = (filter: string) => {
    setCategorySalesMonthFilter(filter);
    setCategorySales(
      categorySales.map((cat) => ({
        ...cat,
        value: Math.floor(Math.random() * cat.target),
      })),
    );
  };

  const [averageDailyCalls, setAverageDailyCalls] = useState(0);
  const [averagePobValue, setAveragePobValue] = useState(0);
  const [averagePodValue, setAveragePodValue] = useState(0);
  const [loading, setLoading] = useState(false);

  // Default to last 3 months for Field Performance
  const getDefaultLast3Months = () => {
    const months = [];
    const now = new Date();
    for (let i = 0; i < 3; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push(
        `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`,
      );
    }
    return months;
  };

  const getMonthsForDateRange = () => {
    if (!dateRange.start || !dateRange.end) {
      return getDefaultLast3Months();
    }

    const months = [];
    const [fromMonth, fromYear] = dateRange.start.split("-");
    const [toMonth, toYear] = dateRange.end.split("-");

    const startDate = new Date(
      Number(fromYear),
      nameToMonthNumber[fromMonth] - 1,
      1,
    );
    const endDate = new Date(Number(toYear), nameToMonthNumber[toMonth] - 1, 1);

    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      months.push(
        `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`,
      );
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return months.reverse();
  };

  const calculateAverages = async () => {
    setLoading(true);
    const positionIds =
      selectedIds.length > 0
        ? selectedIds.join(",")
        : positions.length > 0
          ? positions.map((pos) => pos.id).join(",")
          : (await getFilteredPositionIds("Position", unitId)).join(",");

    const months = getMonthsForDateRange();
    let totalDailyCalls = 0;
    let totalPobValue = 0;
    let totalPodValue = 0;
    let count = 0;

    for (const month of months) {
      const serverUrl = localStorage.getItem("serverUrl");
      const url = `${serverUrl}${API.getEffortReport}`;
      const { status, data }: { status: number; data: { data: any[] } } =
        await getData(url, true, {
          position_id: positionIds,
          moye: month,
        });

      if (status === 200 && Array.isArray(data?.data)) {
        data.data.forEach((item: any) => {
          totalDailyCalls += parseFloat(item.PrimaryDcrAverage || "0");
          totalPobValue += parseFloat(item.PobValue || "0");
          totalPodValue += parseFloat(item.PodValue || "0");
          count++;
        });
      }
    }

    const avgDailyCalls = count > 0 ? totalDailyCalls / count : 0;
    setAverageDailyCalls(avgDailyCalls);
    setAveragePobValue(totalPobValue);
    setAveragePodValue(totalPodValue);
    setLoading(false);
  };

  useEffect(() => {
    calculateAverages();
  }, [positions, selectedIds, unitId]);

  const formatValue = (value: number) => {
    if (value >= 1000000000) {
      return `${(value / 1000000000).toFixed(2)}B`;
    } else if (value >= 1000000) {
      return `${(value / 1000000).toFixed(2)}M`;
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(2)}K`;
    }
    return value.toFixed(2);
  };

  return (
    <div className="powerbi-dashboard-bg py-4 px-2  page-body">
      {/* Filter Section */}
      <div className="row px-3 mb-3 align-items-center">
        <div className="d-flex align-items-end gap-3 flex-wrap justify-content-between">
          {/* <H6 className="mb-0"></H6> */}
          <CardHeaderSpan
            headingClassName="pb-0"
            back={true}
            heading={"Field Performance"}
            span={"Field Performance"}
          />

          <div className="d-flex gap-1">
            <TreeModelReport onSelectionChange={setSelectedIds} />
            <Button color="info" onClick={toggleMonthModal} size="sm">
              {getMonthRangeButtonLabel()}
            </Button>
          </div>
        </div>
      </div>

      {/* Month Range Modal */}
      <Modal
        isOpen={monthModalOpen}
        toggle={toggleMonthModal}
        centered
        className="mt-2"
      >
        <ModalHeader toggle={toggleMonthModal}>Select Month Range</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <label>From</label>
              <select
                className="form-control"
                value={`${monthRange.from.month}-${monthRange.from.year}`}
                onChange={(e) => {
                  const [month, year] = e.target.value.split("-");
                  setMonthRange({ ...monthRange, from: { month, year } });
                }}
              >
                <option value="">Select Month</option>
                {yearOptions.flatMap((year) =>
                  Object.entries(monthNumberToName)
                    .sort(([a], [b]) => Number(b) - Number(a))
                    .filter(([monthNumber]) => {
                      if (year === currentYear) {
                        return Number(monthNumber) <= new Date().getMonth() + 1;
                      }
                      return true;
                    })
                    .map(([_, monthName]) => (
                      <option
                        key={`from-${monthName}-${year}`}
                        value={`${monthName}-${year}`}
                      >
                        {`${monthName}-${year}`}
                      </option>
                    )),
                )}
              </select>
            </Col>
            <Col md={6}>
              <label>To</label>
              <select
                className="form-control"
                value={`${monthRange.to.month}-${monthRange.to.year}`}
                onChange={(e) => {
                  const [month, year] = e.target.value.split("-");
                  setMonthRange({ ...monthRange, to: { month, year } });
                }}
              >
                <option value="">Select Month</option>
                {yearOptions.flatMap((year) =>
                  Object.entries(monthNumberToName)
                    .sort(([a], [b]) => Number(b) - Number(a))
                    .filter(([monthNumber]) => {
                      if (year === currentYear) {
                        return Number(monthNumber) <= new Date().getMonth() + 1;
                      }
                      return true;
                    })
                    .map(([_, monthName]) => (
                      <option
                        key={`to-${monthName}-${year}`}
                        value={`${monthName}-${year}`}
                      >
                        {`${monthName}-${year}`}
                      </option>
                    )),
                )}
              </select>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleMonthModal}>
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={() => {
              setMonthRange({
                from: { month: "", year: "" },
                to: { month: "", year: "" },
              });
              setDateRange({ start: "", end: "" });
              toggleMonthModal();
              // Recalculate with default last 3 months
              setTimeout(() => {
                calculateAverages();
              }, 100);
            }}
          >
            Clear
          </Button>
          <Button color="success" onClick={handleApplyDateRange}>
            Apply
          </Button>
        </ModalFooter>
      </Modal>

      {loading ? (
        <div className="text-center py-3">
          {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
          <div>
            <Image
              className="b-r-10 img-80"
              src={dynamicImage("dashboard/loader.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      ) : (
        <>
          <div style={{ marginLeft: "20px" }}></div>
          <div className="d-flex">
            <div className="col-lg-3 col-md-4 col-sm-6 me-2">
              <Card
                style={{
                  minHeight: "120px",
                  cursor: "pointer",
                }}
              >
                <CardBody
                  style={{
                    padding: "12px",
                    justifyContent: "space-between",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2"
                    style={{ display: "inline-block" }}
                  >
                    <div className="ms-3">
                      <h6
                        className="mb-1"
                        style={{
                          fontSize: "0.9rem",
                          color: "#888",
                          marginBottom: "4px",
                        }}
                      >
                        Calls Average
                      </h6>
                      <h3
                        className="mb-0"
                        style={{
                          fontSize: "1rem",
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        {formatValue(averageDailyCalls)}
                      </h3>
                    </div>
                    <div className={`dashboard-user bg-light-danger`}>
                      <span></span>
                      <SvgIcon
                        iconId={"male"}
                        style={{
                          width: "30px",
                          height: "30px",
                          marginRight: "4px",
                        }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 me-2">
              <Card
                style={{
                  minHeight: "120px",
                  cursor: "pointer",
                }}
              >
                <CardBody
                  style={{
                    padding: "12px",
                    justifyContent: "space-between",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2"
                    style={{ display: "inline-block" }}
                  >
                    <div className="ms-3">
                      <h6
                        className="mb-1"
                        style={{
                          fontSize: "0.9rem",
                          color: "#888",
                          marginBottom: "4px",
                        }}
                      >
                        POB vs POD
                      </h6>
                      <h3
                        className="mb-0"
                        style={{
                          fontSize: "1rem",
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        ₹ {formatValue(averagePobValue)}/
                        {formatValue(averagePodValue)}
                      </h3>
                    </div>
                    <div className={`dashboard-user bg-light-danger`}>
                      <span></span>
                      <SvgIcon
                        iconId={"money"}
                        style={{
                          width: "30px",
                          height: "30px",
                          marginRight: "4px",
                        }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
            {/* <div className="col-lg-2 col-md-4 col-sm-6 me-2">
              <Card
                style={{
                  minHeight: "120px",
                  cursor: "pointer",
                }}
              >
                <CardBody
                  style={{
                    padding: "12px",
                    justifyContent: "space-between",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2"
                    style={{ display: "inline-block" }}
                  >
                    <div className="ms-3">
                      <h6
                        className="mb-1"
                        style={{
                          fontSize: "0.9rem",
                          color: "#888",
                          marginBottom: "4px",
                        }}
                      >
                        All Employees
                      </h6>
                      <h3
                        className="mb-0"
                        style={{
                          fontSize: "1.4rem",
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        150
                      </h3>
                    </div>
                    <div className={`dashboard-user bg-light-danger`}>
                      <span></span>
                      <SvgIcon
                        iconId={"male"}
                        style={{
                          width: "30px",
                          height: "30px",
                          marginRight: "4px",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="customer mt-2"
                    style={{
                      fontSize: "0.8rem",
                      color: "#28a745",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SvgIcon
                      iconId="arrow-up"
                      style={{ width: "18px", height: "18px", marginRight: "4px" }}
                    />
                    <h6>+ 100%</h6>
                  </div>
                </CardBody>
              </Card> 
            </div> */}
          </div>

          {/* <Row className="g-4">
            {chartConfigs
              .filter((c) => visibleCharts.includes(c.id))
              .map((c) => c.render())}
          </Row>
          {visibleCharts.length === 0 && (
            <div className="text-center text-muted py-5">
              No charts selected. Use the filter button to show charts.
            </div>
          )} */}
          {/* Static view: render all charts at the end of the component */}
          <div className="mt-4">
            {/* <h5 className="mb-3">All Charts (Static View)</h5> */}
            <Row className="g-4">
              {chartConfigs.map((c) => (
                <React.Fragment key={`static-${c.id}`}>
                  {c.render()}
                </React.Fragment>
              ))}
            </Row>
          </div>
        </>
      )}
    </div>
  );
}
